import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5, default as _styled6 } from "styled-components";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React, { Fragment, useEffect } from 'react';
import { useTrackableLink } from '@noths/polaris-client-react-hooks';
import { visuallyHidden } from '@noths/polaris-client-styles';
import * as styles from "./SearchSuggestions.styles";
import { useSearchContext } from "../../../context/SearchContext/useSearchContext";
import { useSiteChromeDynamicContext } from "../../../context/SiteChromeDynamicContext/useSiteChromeDynamicContext";
import { createSuggestionSearchEvent } from "../../../hooks/useSearch/tracking";
var Suggestion = function Suggestion(_ref) {
  var currentSearchTerm = _ref.currentSearchTerm,
    isSelected = _ref.isSelected,
    suggestion = _ref.suggestion;
  var _useTrackableLink = useTrackableLink(),
    trackLinkClick = _useTrackableLink.trackLinkClick,
    trackLinkMouseDown = _useTrackableLink.trackLinkMouseDown;
  var trackingEvent = createSuggestionSearchEvent(currentSearchTerm, suggestion);
  return /*#__PURE__*/React.createElement(_StyledLi, {
    "aria-selected": isSelected,
    key: suggestion.name,
    role: "option",
    $_css: styles.item
  }, /*#__PURE__*/React.createElement(_StyledA, {
    href: suggestion.href,
    onClick: trackLinkClick(trackingEvent),
    onMouseDown: trackLinkMouseDown(trackingEvent),
    tabIndex: 0 /* required for e.relatedTarget to not be null in Safari  */,
    $_css2: [styles.link, isSelected && styles.itemSelected]
  }, suggestion.name));
};
export var SearchSuggestions = function SearchSuggestions() {
  var _useSiteChromeDynamic = useSiteChromeDynamicContext(),
    _useSiteChromeDynamic2 = _useSiteChromeDynamic.contentOverlay,
    close = _useSiteChromeDynamic2.close,
    open = _useSiteChromeDynamic2.open;
  var _useSearchContext = useSearchContext(),
    _useSearchContext$sea = _useSearchContext.search,
    isSuggestionsShown = _useSearchContext$sea.isSuggestionsShown,
    searchTerm = _useSearchContext$sea.searchTerm,
    selectedSuggestionId = _useSearchContext$sea.selectedSuggestionId,
    suggestions = _useSearchContext$sea.suggestions,
    suggestionsCount = _useSearchContext$sea.suggestionsCount,
    searchSuggestionsRef = _useSearchContext.searchSuggestionsRef;
  useEffect(function () {
    if (isSuggestionsShown) {
      var _searchSuggestionsRef;
      open((_searchSuggestionsRef = searchSuggestionsRef.current) === null || _searchSuggestionsRef === void 0 ? void 0 : _searchSuggestionsRef.getBoundingClientRect().bottom);
    } else {
      close();
    }
    return function () {
      close();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [suggestions, isSuggestionsShown]);
  var hiddenInstructionalText = function hiddenInstructionalText() {
    var multipleSuggestionsAvailable = suggestionsCount > 1;
    return "".concat(suggestionsCount, " result").concat(multipleSuggestionsAvailable ? 's' : '', " ").concat(multipleSuggestionsAvailable ? 'are' : 'is', " available, use up and down arrow keys to navigate");
  };
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    "data-testid": "search-suggestion",
    ref: searchSuggestionsRef,
    $_css3: styles.container
  }, suggestions.map(function (group, i) {
    return /*#__PURE__*/React.createElement(Fragment, {
      key: i
    }, group.title && /*#__PURE__*/React.createElement(_StyledH, {
      $_css4: styles.title
    }, group.title), /*#__PURE__*/React.createElement(_StyledUl, {
      "aria-label": "Suggestions",
      id: "suggestionList",
      role: "listbox",
      $_css5: styles.list
    }, group.suggestions.map(function (suggestion) {
      return /*#__PURE__*/React.createElement(Suggestion, {
        currentSearchTerm: searchTerm,
        isSelected: selectedSuggestionId === suggestion.globalIndex,
        key: suggestion.name,
        suggestion: suggestion
      });
    })));
  }), /*#__PURE__*/React.createElement(_StyledDiv2, {
    "aria-live": "polite",
    role: "status"
  }, hiddenInstructionalText()));
};
var _StyledLi = _styled("li")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledA = _styled2("a")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css2;
});
var _StyledDiv = _styled3("div")(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css3;
});
var _StyledH = _styled4("h3")(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css4;
});
var _StyledUl = _styled5("ul")(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css5;
});
var _StyledDiv2 = /*#__PURE__*/_styled6("div").withConfig({
  displayName: "SearchSuggestions___StyledDiv2",
  componentId: "sc-53kvx0-0"
})(["", ""], visuallyHidden);